import { Box, Flex, Grid, GridItem, Image, Input, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, Drawer, DrawerOverlay, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerBody, FormControl, FormLabel, Button, Center, Spinner, } from '@chakra-ui/react'
import MyDiv from './gender.style';
import { CustomButton, CustomToast, ActionEditIcon, CustomTable } from '../../../../components';
import { useEffect, useState } from 'react';
import PlusIcon from "../../../../assets/images/Vector.svg";
import { IGender } from './model';
import { useFetch } from '../../../../hooks/useFetch';
import { Column } from "../../../../components/CustomTable/customTable";

const Header = [
    { id: 1, head: 'S. No' },
    { id: 2, head: 'Gender' },
    { id: 3, head: 'Actions' },
];

const Gender = () => {
    const [genders, setGenders] = useState<IGender[]>([]);
    const [DrawerOpen, setDrawerOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<number | null>(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentGender, setCurrentGender] = useState({ id: 0, gender: '' });
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);

    useEffect(() => {
        loadGroup();
    }, []);

    const loadGroup = async () => {
        const response = await fetchApi<IGender[]>("Hrlense_Gender", "GET");
        if (response) setGenders(response);
    };

    const handleAddNewGender = () => {
        setIsEditMode(false);
        setCurrentGender({ id: 0, gender: '' });
        setDrawerOpen(true);
    };

    const handleEditGender = (gender: IGender) => {
        setIsEditMode(true);
        setSelectedId(gender.id);
        setCurrentGender(gender);
        setDrawerOpen(true);
    };

    const handleInputChange = (e: any) => {
      const { name, value } = e.target;
      if (!/^[A-Za-z\s]*$/.test(value)) {
        return;
      }
      setCurrentGender(prev => ({
        ...prev,[name]: value
      }));
    };


    const handleSubmit = async () => {
        if (!currentGender.gender.trim()) {
    addToast({ message: "Please enter Gender", status: "warning" });
    return;
  }
        if (isEditMode) {
            const response = await fetchApi(`Hrlense_Gender/${currentGender.id}`, "PUT", { id: currentGender.id, gender: currentGender.gender, }, null, "Gender updated successfully");

            if (response) setGenders((prev) => prev.map((gender) => (gender.id === selectedId ? currentGender : gender)));
        } else {
            const response = await fetchApi<IGender>("Hrlense_Gender", "POST", { gender: currentGender.gender, }, null, "Gender added successfully");
            if (response) setGenders((prev) => [...prev, response]);
        }
        setDrawerOpen(false);
    };

    return (
        <MyDiv>
           <Box position="relative" minH="300px">
             {loading ? (
            <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
            </Center>) : (
            <>
            <Flex className="page_heading flex_header" >
                <Text className="font-poppins text_semibold text_3xl">Gender </Text>
                <Flex gap={2}>
                    <CustomButton title="Add New Gender" className=' btn font-poppins text_sm text_medium' rightIcon={<Image src={PlusIcon} className='logo' />} onClick={handleAddNewGender} />
                </Flex>
            </Flex>
            <Grid className='grid_container'>
                <GridItem colSpan={12}>
                    <CustomTable value={genders} >
                      <Column header="S. No" body={(_, index) => index + 1} />
                      <Column header="Gender" field="gender" />
                      <Column
                        header="Actions"
                        body={(row: any) => (<ActionEditIcon onClick={() => handleEditGender(row)} />
                        )}
                      />
                    </CustomTable>

                </GridItem>
            </Grid>

            <Drawer isOpen={DrawerOpen} placement="right" onClose={() => setDrawerOpen(false)} size="sm">
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader borderBottomWidth="1px">{isEditMode ? 'Edit Gender' : 'Add New Gender'}</DrawerHeader>
                    <DrawerBody display="flex" flexDirection="column" justifyContent="space-between" height="100%">
                        <Box py={4}>
                            <FormControl mb={4} isRequired>
                                <FormLabel>Gender Name</FormLabel>
                                <Input name="gender" value={currentGender.gender} onChange={handleInputChange} placeholder="Enter gender name" />
                            </FormControl>
                        </Box>
                        <Flex justify="flex-end" mt={4} gap={2}>
                            <Button className="font-poppins text_sm text_medium" onClick={() => setDrawerOpen(false)} style={{ backgroundColor: '#D92F34', color: 'white' }}>Cancel</Button>
                            <Button onClick={handleSubmit} className="font-poppins text_sm text_medium" style={{ backgroundColor: '#006838', color: 'white' }}>{isEditMode ? "Update Gender" : "Add Gender"}</Button>
                        </Flex>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>           
      </>)}
    </Box>
        </MyDiv>
    )
}

export default Gender;
